export default {
  edit_profile: 'Profili Düzenle',
  my_account: 'Kullanıcı',
  balance: 'Bakiye',
  available_for_withdrawal: 'Çekilebilir',
  amount_in_hold: 'Beklemedeki tutar',
  latest_news: 'Son haberler',
  more_news: 'Daha fazla haber'
};